import { Component } from '@angular/core';
import { RefComponent } from '../../components/ref/ref.component';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-references',
  standalone: true,
  imports: [RefComponent, TranslateModule],
  templateUrl: './references.component.html',
  styleUrl: './references.component.css',
})
export class ReferencesComponent {}
